// Busca de cliente do BALCÃO (pedido do dono, 29/09/2026): a mesma das Mesas —
// nome, telefone, CPF ou e-mail, no servidor, 250 ms depois de digitar. Só vale
// cliente do cadastro (decisão do dono): escolher da lista liga o pedido ao
// cliente (cashback, histórico, vai junto na Entrega para o Delivery); não achou
// → "Cadastrar novo cliente". ↑↓ andam na lista, Enter escolhe o aceso, Esc
// limpa. F2 (nas telas de consumo e pagamento) traz o cursor para cá.
import { Search, UserPlus } from "lucide-react";
import { useEffect, useState } from "react";

import CadastroClienteDialog from "./CadastroClienteDialog";
import { totemApi } from "../api";

export const ID_BUSCA_CLIENTE = "balcao-busca-cliente";

export default function BuscaClienteBalcao({ onEscolher }) {
  const [termo, setTermo] = useState("");
  const [busca, setBusca] = useState({ termo: "", lista: [] });
  const [aceso, setAceso] = useState(0);
  const [aberta, setAberta] = useState(false);
  const [cadastro, setCadastro] = useState(false);
  const t = termo.trim();
  useEffect(() => {
    if (t.length < 2) return undefined;
    let vivo = true;
    const timer = setTimeout(() => {
      totemApi.buscarClientes(t)
        .then(({ data }) => { if (vivo) setBusca({ termo: t, lista: Array.isArray(data) ? data : [] }); })
        .catch(() => { if (vivo) setBusca({ termo: t, lista: [] }); });
    }, 250);
    return () => { vivo = false; clearTimeout(timer); };
  }, [t]);
  useEffect(() => { setAceso(0); }, [busca]);
  const buscando = t.length >= 2 && busca.termo !== t;
  const lista = t.length >= 2 && !buscando ? busca.lista : [];
  // Itens do menu: os clientes achados e, no fim, "Cadastrar novo cliente".
  const total = lista.length + 1;
  const escolher = (c) => { onEscolher(c); setTermo(""); setAberta(false); };
  const acionar = (i) => { if (i < lista.length) escolher(lista[i]); else { setAberta(false); setCadastro(true); } };
  const tecla = (e) => {
    // Tab / Shift+Tab também andam na lista (30/09/2026), como as setas.
    if ((e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) && t.length >= 2) { e.preventDefault(); setAberta(true); setAceso((a) => (a + 1) % total); }
    else if ((e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey)) && t.length >= 2) { e.preventDefault(); setAberta(true); setAceso((a) => (a - 1 + total) % total); }
    // Com algo digitado, o Enter é da busca (nunca avança a tela com um nome solto).
    else if (e.key === "Enter" && termo.trim()) { e.preventDefault(); if (t.length >= 2 && !buscando) acionar(aceso); }
    else if (e.key === "Escape" && termo) { e.preventDefault(); setTermo(""); setAberta(false); }
  };
  return (
    <div className="relative w-80">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500 pointer-events-none" />
        <input
          id={ID_BUSCA_CLIENTE} data-e2e={ID_BUSCA_CLIENTE} value={termo} autoComplete="off"
          onChange={(e) => { setTermo(e.target.value); setAberta(true); }} onFocus={() => setAberta(true)}
          onBlur={() => setTimeout(() => setAberta(false), 150)} onKeyDown={tecla}
          placeholder="Cliente: nome, telefone ou CPF (F2)"
          className="w-full h-10 pl-9 pr-3 rounded-md text-center bg-zinc-800 border border-zinc-700 text-zinc-100 placeholder:text-zinc-500 focus:outline-none focus:border-orange-500"
        />
      </div>
      {aberta && t.length >= 2 && (
        <div className="absolute top-full left-0 right-0 mt-1 z-50 bg-zinc-900 border border-zinc-700 rounded-lg shadow-xl max-h-64 overflow-y-auto text-left" data-e2e="lista-clientes-balcao">
          {buscando && <p className="px-3 py-2.5 text-sm text-zinc-500">Buscando…</p>}
          {lista.map((c, i) => (
            <button key={c.id} type="button" onMouseDown={(e) => { e.preventDefault(); escolher(c); }} onMouseEnter={() => setAceso(i)}
              data-e2e="cliente-opcao" className={`w-full px-3 py-2.5 text-sm flex justify-between gap-3 ${aceso === i ? "bg-orange-500/15" : "hover:bg-zinc-800"}`}>
              <span className="font-medium text-zinc-100 truncate">{c.nome}</span>
              <span className="text-zinc-500 text-xs shrink-0">{c.telefone || c.cpf || ""}</span>
            </button>
          ))}
          {!buscando && (
            <button type="button" onMouseDown={(e) => { e.preventDefault(); acionar(lista.length); }} onMouseEnter={() => setAceso(lista.length)}
              data-e2e="cliente-cadastrar" className={`w-full px-3 py-2.5 text-sm flex items-center gap-2 text-orange-400 font-medium ${aceso === lista.length ? "bg-orange-500/15" : "hover:bg-zinc-800"}`}>
              <UserPlus className="w-4 h-4 shrink-0" /> {lista.length ? "Cadastrar novo cliente" : "Não achou — cadastrar novo cliente"}
            </button>
          )}
        </div>
      )}
      <CadastroClienteDialog aberto={cadastro} sugestao={termo} onFechar={() => setCadastro(false)}
        onCriado={(c) => { setCadastro(false); escolher(c); }} />
    </div>
  );
}
